import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Transform } from 'class-transformer';
import { isDefined, IsOptional, MaxLength, MinLength } from 'class-validator';


import { FIELD_INVALID_LENGTH } from '../constants';
import { BaseDecoratorOptions } from '../types';

type PropertyPasswordParams = BaseDecoratorOptions<string> & Pick<ApiPropertyOptions, 'minLength' | 'maxLength'>;

export function ApiPropertyPassword({ isOptional, ...options }: PropertyPasswordParams): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: 'string',
    example: 'Abracadabra1234!',
    ...options,
  };

  const { minLength, maxLength } = options;
  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    ...(isDefined(minLength) ? [MinLength(minLength!, { message: FIELD_INVALID_LENGTH, context: { minLength } })] : []),
    ...(isDefined(maxLength) ? [MaxLength(maxLength!, { message: FIELD_INVALID_LENGTH, context: { maxLength } })] : []),
    Transform(({ value }) => value && value.trim()),
  );
}
